/* tslint:disable */
/* eslint-disable */
/**
 * Lemonway DirectKit API 2.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { TransactionOut } from './TransactionOut';
import {
    TransactionOutFromJSON,
    TransactionOutFromJSONTyped,
    TransactionOutToJSON,
} from './TransactionOut';

/**
 * 
 * @export
 * @interface CancelMoneyOutOutput
 */
export interface CancelMoneyOutOutput {
    /**
     * 
     * @type {TransactionOut}
     * @memberof CancelMoneyOutOutput
     */
    transaction?: TransactionOut;
    /**
     * 
     * @type {Error}
     * @memberof CancelMoneyOutOutput
     */
    error?: Error;
}

/**
 * Check if a given object implements the CancelMoneyOutOutput interface.
 */
export function instanceOfCancelMoneyOutOutput(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function CancelMoneyOutOutputFromJSON(json: any): CancelMoneyOutOutput {
    return CancelMoneyOutOutputFromJSONTyped(json, false);
}

export function CancelMoneyOutOutputFromJSONTyped(json: any, ignoreDiscriminator: boolean): CancelMoneyOutOutput {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'transaction': !exists(json, 'transaction') ? undefined : TransactionOutFromJSON(json['transaction']),
        'error': !exists(json, 'error') ? undefined : json['error'],
    };
}

export function CancelMoneyOutOutputToJSON(value?: CancelMoneyOutOutput | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'transaction': TransactionOutToJSON(value.transaction),
        'error': value.error,
    };
}

